import React from "react";
import { Download, Share, X } from "lucide-react";
import { usePwaInstall } from "../../contexts/PwaInstallContext";
import { useLanguage } from "../../contexts/LanguageContext";

function PwaInstallPrompt() {
  const { open, dismiss, install, canNativeInstall, isIos } = usePwaInstall();
  const { lang } = useLanguage();
  const hi = lang === "hi";

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1100] flex items-end sm:items-center justify-center p-4 bg-black/45" role="dialog" aria-modal="true">
      <div className="bg-card text-foreground w-full max-w-md rounded-2xl shadow-xl border border-border p-5 relative">
        <button
          type="button"
          onClick={dismiss}
          className="absolute right-3 top-3 min-h-10 min-w-10 flex items-center justify-center rounded-lg text-muted-foreground hover:bg-muted"
          aria-label={hi ? "बंद करें" : "Close"}
        >
          <X size={18} />
        </button>
        <div className="flex items-start gap-3 pr-8">
          <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
            <Download size={22} />
          </div>
          <div>
            <h2 className="text-base font-bold m-0">
              {hi ? "EmergencyQR ऐप इंस्टॉल करें" : "Install the EmergencyQR app"}
            </h2>
            <p className="text-sm text-muted-foreground mt-1.5 mb-0 leading-snug">
              {hi
                ? "होम स्क्रीन पर जोड़ें ताकि आपातकाल में तेज़ी से खुल सके — इंटरनेट धीमा होने पर भी।"
                : "Add it to your home screen for faster access in an emergency, even on a slow connection."}
            </p>
          </div>
        </div>

        {isIos && !canNativeInstall ? (
          <ol className="mt-4 space-y-2 text-sm text-foreground list-decimal pl-5 m-0">
            <li className="leading-snug">
              {hi ? (
                <>
                  Safari में नीचे <Share size={14} className="inline align-text-bottom" /> Share टैप करें
                </>
              ) : (
                <>
                  Tap <Share size={14} className="inline align-text-bottom" /> Share in Safari
                </>
              )}
            </li>
            <li className="leading-snug">
              {hi ? "“Add to Home Screen” चुनें" : "Choose “Add to Home Screen”"}
            </li>
            <li className="leading-snug">{hi ? "Add टैप करें" : "Tap Add"}</li>
          </ol>
        ) : null}

        <div className="mt-5 flex flex-col gap-2">
          {canNativeInstall ? (
            <button
              type="button"
              onClick={() => install()}
              className="checkout-btn checkout-btn--primary w-full justify-center"
            >
              {hi ? "इंस्टॉल करें" : "Install app"}
            </button>
          ) : !isIos ? (
            <p className="text-xs text-muted-foreground m-0 text-center">
              {hi
                ? "ब्राउज़र मेनू में “Install app” या “Add to Home screen” देखें।"
                : "Use your browser menu → Install app / Add to Home screen."}
            </p>
          ) : null}
          <button type="button" onClick={dismiss} className="checkout-btn checkout-btn--secondary w-full justify-center">
            {hi ? "बाद में" : "Not now"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PwaInstallPrompt;
